<template>
  <div id="contenedor-agregar-nueva-obra">
    <v-form ref="registrarNuevaObra" v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar Nueva Obra
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="2">
            <custom-select
              v-model="obra.ejercicio"
              label="Ejercicio*"
              :items="getEjerciciosRange"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-text-field
              v-model="obra.clave"
              label="Clave*"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="d-flex align-center">
            <Select
              v-model="obra.etiquetas"
              label="Etiquetas"
              :items="getEtiquetas"
              deletable-chips
              multiple
              small-chips
              hide-details
              item-text="title"
              item-value="id">
            </Select>
          </v-col>
          <v-col class="d-flex align-center">
            <v-btn icon @click="mostrarDialogNuevaEtiqueta = true">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <custom-text-area
              v-model="obra.meta"
              label="Meta*"
              :rules="[mixReglas.requerido]"
              auto-grow
              required
            >
            </custom-text-area>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.importe"
              label="Importe"
              esDinero
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.importeIva"
              label="Importe IVA"
              esDinero
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.total"
              label="Total"
              esDinero
            >
            </custom-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.etapa"
              label="Etapa"
              :items="itemsetapa"
              item-text="etapa"
              item-value="valor"
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.idTipo"
              label="Tipo de Obra*"
              :items="tiposObras"
              :rules="[mixReglas.requerido]"
              item-text="descripcion"
              item-value="id"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.idSubtipo"
              label="SubTipo de Obra*"
              :items="getSubTipoObraPorTipo"
              item-text="descripcion"
              item-value="id"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.tipoProyecto"
              label="Tipo de Proyecto"
              :items="itemstipodeproyecto"
              item-text="proyecto"
              item-value="valor"
            >
            </custom-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <custom-select
              v-model="obra.idPrograma"
              label="Programa"
              :items="programasInversiones"
              item-text="nombre"
              item-value="id"
              required
            >
            </custom-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <custom-select
              v-model="obra.ubicacion.idMunicipio"
              label="Municipio*"
              :items="municipios"
              item-text="nombre"
              item-value="id"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model="obra.ubicacion.localidad"
              label="Localidad*"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              required
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model="obra.ubicacion.ubicacion"
              label="Ubicación*"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              required
            >
            </custom-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaSolicitudRecursos"
              label="Fecha de Solicitud de Recursos"
            >
            </custom-date-picker>
          </v-col> -->
          <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaProbableInicio"
              label="Fecha Probable de Inicio"
            >
            </custom-date-picker>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaProbableTermino"
              label="Fecha Probable de Termino"
            >
            </custom-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels accordion flat>
            <v-expansion-panel @click="showhide">
              <v-expansion-panel-header>
                <v-card-title>Datos Opcionales de la Ubicación</v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <custom-select
                      v-model="obra.ubicacion.idMunicipio"
                      label="Municipio*"
                      :items="municipios"
                      item-text="nombre"
                      item-value="id"
                      :rules="[mixReglas.requerido]"
                      required
                    >
                    </custom-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <custom-text-field
                      v-model="obra.ubicacion.localidad"
                      label="Localidad*"
                      :rules="[mixReglas.requerido]"
                      required
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-select
                      v-model="obra.ubicacion.tipoLocalidad"
                      label="Tipo de Localidad"
                      :items="itemstipolocalidad"
                    >
                    </custom-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <custom-text-field
                      v-model="obra.ubicacion.ubicacion"
                      label="Ubicación*"
                      :rules="[mixReglas.requerido]"
                      required
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model="obra.ubicacion.latitud"
                      label="Latitud"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model="obra.ubicacion.longitud"
                      label="Longitud"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="8">
                    <custom-text-field
                      v-model="obra.ubicacion.sitio"
                      label="Sitio"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-switch
                      v-model="obra.ubicacion.cabeceraMunicipial"
                      inset
                      label="¿Es Cabecera Municipal?"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title> Datos Opcionales del Impacto </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model.number="obra.impacto.beneficiados"
                      label="Beneficiados"
                      type="number"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model.number="obra.impacto.metaFisica"
                      label="Meta Fisica"
                      type="number"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model="obra.impacto.metaFisicaUnidad"
                      label="Unidad Meta Fisica"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.justificacionTecnica"
                      label="Justificación Técnica"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model.number="obra.impacto.avanceFisicoActual"
                      prefix="%"
                      label="Avance Fisico Actual"
                      type="number"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model.number="obra.impacto.avanceProgramadoCierre"
                      prefix="%"
                      label="Avance Programado Cierre"
                      type="number"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.descripcionTotalObra"
                      label="Descripcion Total Obra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.conceptosEjecutar"
                      label="Conceptos a ejecutar de la obra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.problematica"
                      label="Problematica"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.justificacionSocial"
                      label="Justificación Social"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarObra"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-dialog v-model="mostrarDialogNuevaEtiqueta" max-width="450px" scrollable>
      <nueva-etiqueta
        @cerrar="cerrarAgregarEtiqueta"
        :modulo="'OBRAS'">
      </nueva-etiqueta>
    </v-dialog>
  </div>
</template>

<script>
import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Select from '@/components/inputs/sinColumnas/Select.vue';
import NuevaEtiqueta from '@/components/administracion/configuracion/catalogos/etiquetas/Nueva.vue';
import mixObras from './mixObras';

const hoy = new Date();

// TODO crear formulario con los siguientes campos
// Campo de la Obra en general:
// idPrograma: ID, (Catalogo), idTipo: ID!, (Catalogo), idSubtipo: ID!, (Catalogo)
// ejercicio: Int!, clave: String!, meta: String!,
// etapa: Int, (1=> Nueva, 2 => Amplicación, 3 => Rehabilitación)
// tipoProyecto: Int, (1 => Social, 2 => Productivo, 3 => Apoyo), fechaSolicitudRecursos: String,
// fechaProbableInicio: String, fechaProbableTermino: String,

// Campos de la ubicacion de la obra:
// idMunicipio: String!, ubicacion: String!, localidad: String!, latitud: String, longitud: String,
// sitio: String, cabeceraMunicipial: Boolean, tipoLocalidad: String,

// Campos del impacto de la obra (Todos opcionales, pero se tienen que mandar):
// beneficiados: Int, metaFisica: Int, metaFisicaUnidad: String, justificacionTecnica: String,
// justificacionSocial: String, problematica: String, avanceFisicoActual: Float,
// avanceProgramadoCierre: Float, descripcionTotalObra: String, conceptosEjecutar: String,

export default {
  name: 'ObrasNuevo',
  mixins: [mixObras],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomTextArea,
    CustomDatePicker,
    CustomButton,
    Select,
    NuevaEtiqueta,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarcamposubicacion: true,
      mostrarDialogNuevaEtiqueta: false,
      itemsetapa: [
        { etapa: 'Nueva', valor: 1 },
        { etapa: 'Ampliación', valor: 2 },
        { etapa: 'Rehabilitación', valor: 3 },
      ],
      itemstipodeproyecto: [
        { proyecto: 'Social', valor: 1 },
        { proyecto: 'Productivo', valor: 2 },
        { proyecto: 'Apoyo', valor: 3 },
      ],
      itemstipolocalidad: ['Urbana', 'Rural'],
      etiquetasFiltros: {
        modulo: 'OBRAS',
      },
      obra: {
        idPrograma: '', // (Catalogo)
        idTipo: '', // (Catalogo)
        idSubtipo: '', // (Catalogo)
        ejercicio: hoy.getFullYear(),
        clave: '',
        meta: '',
        importe: 0,
        importeIva: 0,
        total: 0,
        etapa: 0, // (1=> Nueva, 2 => Amplicación, 3 => Rehabilitación)
        tipoProyecto: 0, // (1 => Social, 2 => Productivo, 3 => Apoyo)
        fechaSolicitudRecursos: null,
        fechaProbableInicio: null,
        fechaProbableTermino: null,
        ubicacion: {
          idMunicipio: '', // (Catalogo)
          ubicacion: '',
          localidad: '',
          latitud: '',
          longitud: '',
          sitio: '',
          cabeceraMunicipial: false,
          tipoLocalidad: '',
        },
        impacto: {
          beneficiados: 0,
          metaFisica: 0,
          metaFisicaUnidad: '',
          justificacionTecnica: '',
          justificacionSocial: '',
          problematica: '',
          avanceFisicoActual: 0, // Float
          avanceProgramadoCierre: 0, // Float
          descripcionTotalObra: '',
          conceptosEjecutar: '',
        },
        etiquetas: [],
      },
    };
  },
  apollo: {
    etiquetas: {
      query: ETIQUETAS,
      variables() {
        return {
          filtros: this.etiquetasFiltros,
        };
      },
    },
  },
  computed: {
    getEjerciciosRange() {
      const anioActual = hoy.getFullYear();
      return this.$range(2021, (anioActual + 2)).reverse();
    },
    getEtiquetas() {
      return this.etiquetas ? this.etiquetas.map((etiqueta) => ({
        title: etiqueta.nombre,
        subtitle: null,
        avatar: '',
        id: etiqueta.id,
      })) : [];
    },
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    cerrarAgregarEtiqueta() {
      this.mostrarDialogNuevaEtiqueta = false;
    },
    limpiarFormulario() {
      this.$refs.registrarNuevaObra.reset();
    },
    showhide() {
      this.mostrarcamposubicacion = !this.mostrarcamposubicacion;
    },
  },
};
</script>
